<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">Lista de Distribuidores</h2>

  <div class="row form-group">
    <div class="form-group col-md-9">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-md-3">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <ag-grid-angular class="{{distribuidorModulo.agGrid.class}}" #agGrid [ngStyle]="distribuidorModulo.agGrid.style"
        id="{{distribuidorModulo.agGrid.id}}" [paginationPageSize]="distribuidorModulo.agGrid.paginacion"
        [pagination]="true" [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs"
        [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <button [routerLink]="['/distribuidor/home']" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
 </div>
</ng-template>


<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>
  <form [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-4" >
        <app-lfsa-input [class]="'letrasDanger'" [placeholder]="'Ingrese Cod.Distribuidor'" [label]="'Cod.Distribuidor*'" [id]="'id'" [formControlName]="modelGridDistribuidor.idDistribuidor"
          [control]="formulario.get(modelGridDistribuidor.idDistribuidor)"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4" >
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese RUC'" [label]="'RUC*'" [id]="'ruc'" [formControlName]="modelGridDistribuidor.ruc"
          [control]="formulario.get(modelGridDistribuidor.ruc)"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4" >
        <app-lfsa-input [class]="'letrasDanger'" [placeholder]="'Ingrese Nombre Distribuidor'" [label]="'Nombre Distribuidor*'" [id]="'nombre'" [formControlName]="modelGridDistribuidor.nombreDistribuidor"
          [control]="formulario.get(modelGridDistribuidor.nombreDistribuidor)"></app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12 col-md-6" >
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Email'" [label]="'Email*'" [id]="'email'" [formControlName]="modelGridDistribuidor.email"
          [control]="formulario.get(modelGridDistribuidor.email)"></app-lfsa-input>
      </div>
      <!-- <div class="form-group col-12 col-md-4" >
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Efectividad'" [label]="'Efectividad*'" [id]="'id'" [formControlName]="modelGridDistribuidor.efectividad"
          [control]="formulario.get(modelGridDistribuidor.efectividad)"></app-lfsa-input>
      </div> -->
      <div class="form-group col-12 col-md-6" >
        <app-lfsa-input [class]="'letrasDanger'" [placeholder]="'Ingrese Cod.Vendedor'" [label]="'Cod.Vendedor*'" [id]="'vendedor'" [formControlName]="modelGridDistribuidor.idVendedor"
          [control]="formulario.get(modelGridDistribuidor.idVendedor)"></app-lfsa-input>
      </div>
    </div>
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </form>
  <!-- {{ formulario.value | json}} -->
</ng-template>
